/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vekn_Guidance_Claim_LinkInputs */



/**
* | output |
* | --- |
* | "Claim it on your profile" |
*
* @param {Vekn_Guidance_Claim_LinkInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const vekn_guidance_claim_link = /** @type {((inputs?: Vekn_Guidance_Claim_LinkInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vekn_Guidance_Claim_LinkInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Revendiquez-le sur votre profil")
	if (locale === "es") return /** @type {LocalizedString} */ ("Reclámalo en tu perfil")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Reivindique-o em seu perfil")
	if (locale === "it") return /** @type {LocalizedString} */ ("Reclamalo nel tuo profilo")
	return /** @type {LocalizedString} */ ("Claim it on your profile")
});